export const HEEDIFY_POWERBI_SERVICES_PATH = "https://func-pbi-services-prod-ne.azurewebsites.net/api/V2/";
export const HEEDIFY_PROVISIONING_SERVICES_PATH="https://provisioning.heedify.io/"
export const HEEDIFY_REDIRECT_URI="https://reports.heedify.io/"